<template>
  <div class="empty-list">
    <div class="title">{{ title }}</div>
    <div class="message">{{ message }}</div>
    <button class="button primary" @click="onClickButton">{{ actionName }}</button>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    isModeAssociatedNovels: Boolean,
  },
  computed: {
    title() {
      return this.isModeAssociatedNovels
        ? this.$t('nolaNovelEmptyList.posted.title')
        : this.$t('nolaNovelEmptyList.nonPosted.title');
    },
    message() {
      return this.isModeAssociatedNovels
        ? this.$t('nolaNovelEmptyList.posted.message')
        : this.$t('nolaNovelEmptyList.nonPosted.message');
    },
    actionName() {
      return this.isModeAssociatedNovels
        ? this.$t('nolaNovelEmptyList.posted.actionButton')
        : this.$t('nolaNovelEmptyList.nonPosted.actionButton');
    },
  },
  methods: {
    onClickButton() {
      const { isModeAssociatedNovels } = this;
      if (isModeAssociatedNovels) this.$emit("clickNonAssociatedNovels");
      else this.$router.push({ name: "novelCreate" });
    },
  },
});

interface Props {
  isModeAssociatedNovels: boolean;
}

interface Data {}

interface Computed {
  title: string;
  message: string;
  actionName: string;
}

interface Methods {
  onClickButton(): void;
}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.empty-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;

  .title {
    color: var(--color-text-low);
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-lg);
  }

  .message {
    color: var(--color-text-low);
    font-size: var(--font-size-md);
    margin: 10px 0 30px;
  }

  .button {
    position: relative;
    @include hover-overlay;
    margin: 0;
    padding: 15px;
    border-radius: var(--radius-sm);
    font-size: 1.1em;
    font-weight: var(--font-weight-bold);
    cursor: pointer;
    transition: filter 0.2s ease;

    color: var(--color-text-on-fixed-bg);
    background-color: var(--color-primary);
    border-color: var(--color-primary);

  }
}
</style>
